module.exports = __webpack_public_path__ + "img/numbers.11d12c61.gif";